<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="[getSelectedDEV && 'dev-selected-component']"
  >
    <v-carousel v-bind="schema.attributesCarousels">
      <v-carousel-item
        v-for="(item, i) in schema.items"
        :key="i"
        v-bind="schema.attributesCarouselsItem"
        :src="item.src"
      >
        <div class="c-slide">
          <v-row :class="['fill-height', 'c-content', item.src ? '' : item.background]">
            <div :class="['c-title', item.title_class]">{{ item.title }}</div>
            <div :class="['c-text', item.description_class]">{{ item.description }}</div>
          </v-row>
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin]
};
</script>

<style lang="scss" scoped>
.c-slide {
  display: flex;
  justify-content: space-between;
  align-content: center;
  flex-direction: row;
  height: 100%;

  .c-content {
    display: flex;
    flex-direction: row;
    align-content: center;

    .c-title {
      width: 100%;
      text-align: center;
    }

    .c-text {
      width: 100%;
      padding: 0 80px;
    }
  }
}
</style>
